import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Search, ChevronRight } from 'lucide-react';
import { Input } from '../components/ui/input';
import { metaApi } from '../api/client';
import SEO from '../components/SEO';

export default function Cities() {
  const [q, setQ] = useState('');
  const [cities, setCities] = useState([]);
  useEffect(() => { metaApi.cities().then(setCities).catch(() => {}); }, []);
  const filtered = cities.filter(c => c.count > 0).filter(c => c.name.toLowerCase().includes(q.toLowerCase()) || c.state.toLowerCase().includes(q.toLowerCase()));

  // group by state
  const byState = filtered.reduce((acc, c) => {
    (acc[c.state] = acc[c.state] || []).push(c);
    return acc;
  }, {});

  return (
    <div>
      <SEO title="Advogados por cidade no Brasil" description="Encontre escritórios de advocacia nas principais cidades brasileiras. Navegue por São Paulo, Rio de Janeiro, Belo Horizonte e mais." />
      <div className="bg-white border-b border-[#cbd8dc] text-[#122f36]">
        <div className="aj-wrap py-14">
          <nav className="text-xs text-[#52676e] mb-4">
            <Link to="/" className="hover:text-[#063f4c]">Início</Link> / Cidades
          </nav>
          <h1 className="text-3xl md:text-4xl font-semibold">Advogados por cidade</h1>
          <p className="text-[#354c54] mt-2 max-w-2xl">Encontre escritórios de advocacia em sua cidade. Navegue por região ou busque diretamente.</p>
          <div className="mt-6 max-w-md relative">
            <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-[#6b858e]" />
            <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Buscar cidade ou estado (ex: SP, Rio...)" className="pl-9 h-11 bg-white text-[#243b42]" />
          </div>
        </div>
      </div>

      <div className="aj-wrap py-12">
        {Object.entries(byState).sort().map(([state, cities]) => (
          <div key={state} className="mb-10">
            <h2 className="text-xs font-semibold text-[#075a6d] uppercase tracking-widest mb-3">Estado de {state}</h2>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
              {cities.map(city => (
                <Link key={city.slug} to={`/cidade/${city.slug}`} className="group flex items-center justify-between bg-white border border-[#cbd8dc] rounded-[7px] p-4 hover:border-[#547a83] hover:border-[#547a83] transition-all">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-[7px] bg-[#f2f6f7] group-hover:bg-[#153e44] flex items-center justify-center transition-colors">
                      <MapPin className="w-5 h-5 text-[#153e44] group-hover:text-[#075a6d]" />
                    </div>
                    <div>
                      <div className="font-semibold text-[#153e44] text-sm">{city.name}</div>
                      <div className="text-xs text-[#52676e]">{city.count} {city.count === 1 ? 'escritório' : 'escritórios'}</div>
                    </div>
                  </div>
                  <ChevronRight className="w-4 h-4 text-[#6b858e] group-hover:text-[#075a6d]" />
                </Link>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
